<template>
    <div class="index-content">
        <!--导航栏-->
        <div class="nav-bar">
            <el-affix :z-index="maxZIndex">
                <NavBar></NavBar>
            </el-affix>

        </div>

        <!--轮播-->
        <div class="swiper">
            <Swiper @viewport="onViewport"></Swiper>
        </div>

        <!--公司介绍-->
        <div class="wow animate__fadeInUpBig company-profile">
            <div class="title">
                {{ t('index.companyProfile.title') }}
            </div>

            <div class="introduce-text">
                {{ $t('index.companyProfile.introduce') }}
            </div>

            <div class="learn-more-button" @click="goAboutUsPage">
                LEARN MORE
            </div>
        </div>

        <!--热销产品-->
        <HotSales></HotSales>

        <!--优势-->
        <div class="advantage wow animate__fadeInUpBig">
            <div class="advantage-pc">
                <div class="advantage-item" v-for="(item,index) in ($tm('index.advantage') as any)" :key="index">
                    <div class="top">
                        {{ item.top }}
                    </div>
                    <div class="bottom">
                        {{ item.bottom }}
                    </div>
                </div>
            </div>

            <div class="advantage-phone">
                <div class="advantage-item" v-for="(item,index) in ($tm('index.advantage') as any)" :key="index">
                    <div class="top">
                        {{ item.top }}
                    </div>
                    <div class="bottom">
                        {{ item.bottom }}
                    </div>
                </div>
            </div>
        </div>

        <!--选择我们-->
        <div class="choose-us wow animate__fadeInUpBig">
            <div class="top">
                <div class="title">
                    {{ $t('index.chooseUs.title') }}
                </div>
                <div class="tips">
                    {{ $t('index.chooseUs.tips') }}
                </div>
            </div>

            <div class="bottom">
                <div class="choose-item" v-for="(item,index) in chooseUsItem" :key="index">
                    <div class="left-icon" >
                        <i :class="[
                            'iconfont',item.icon
                        ]"></i>
                    </div>
                    <div class="right-content">
                        <div class="title">
                            {{ $t(item.title) }}
                        </div>
                        <div class="tips">
                            {{ $t(item.tips) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--页脚-->
        <Footer></Footer>

        <!--悬浮按钮-->
        <FloatButton ref="floatButtonRef"></FloatButton>
    </div>
</template>

<script setup lang="ts">
import NavBar from '@/components/NavBar.vue'
import { UtilMethods } from '@/util/UtilMethods'
import Swiper from '@/components/Swiper.vue'
import FloatButton from '@/components/FloatButton.vue'
import { onBeforeMount, onMounted, Ref, ref } from 'vue'
import { Action, LanguageType } from '@/typeDefine/CommonTypes'
import HotSales from '@/components/HotSales.vue'
import Footer from '@/components/Footer.vue'
import { useI18n } from 'vue-i18n'
import { LanguagePackageType } from '@/typeDefine/EntityType'
import { router } from '@/router'

const { t} = useI18n<[LanguagePackageType], LanguageType>()

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

//floatButton子组件ref
const floatButtonRef: Ref<InstanceType<typeof FloatButton> | null> = ref(null)

//选择我们的理由
const chooseUsItem = [
    {
        title: 'index.chooseUs.chooseItem[0].title',
        icon: `icon-youshi_youzhi`,
        tips: 'index.chooseUs.chooseItem[0].tips',
    },
    {
        title: 'index.chooseUs.chooseItem[1].title',
        icon: `icon-youshi_youzhi`,
        tips: 'index.chooseUs.chooseItem[1].tips',
    },
    {
        title: 'index.chooseUs.chooseItem[2].title',
        icon: `icon-youshi_youzhi`,
        tips: 'index.chooseUs.chooseItem[2].tips',
    }
] as const

//监听轮播视口事件
const onViewport: Action<[boolean]> = (value: boolean) => {
    if (floatButtonRef.value) {
        floatButtonRef.value.floatButtonDisplayHandler(value)
    }
}

const goAboutUsPage: Action = () => {
    router.push({
        name: 'aboutUs'
    })
}

</script>

<style lang="css" scoped>
.index-content {
    box-sizing: border-box;
}

.index-content .company-profile {
    width: 87.5%;
    margin: 50px auto;
    text-align: center;
}

.index-content .company-profile .title {
    font-size: 40px;
}

.index-content .company-profile .introduce-text {
    margin: 50px 0;
    line-height: 30px;
}

.index-content .company-profile .learn-more-button {
    border: 2px solid #c3d8db;
    color: var(--primary-color);
    width: 10%;
    margin: 50px auto;
    padding: 15px 60px;
    cursor: pointer;
    transition: all 0.6s ease;
}

.index-content .company-profile .learn-more-button:hover {
    background-color: var(--primary-color);
    color: #fff;
    border: 2px solid var(--primary-color);
}

.index-content .advantage {
    background-color: var(--primary-color);
    margin-top: 50px;
    height: 240px;
}

.index-content .advantage .advantage-pc {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.index-content .advantage .advantage-pc .advantage-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 100%;
    color: #fff;
}

.index-content .advantage .advantage-pc .advantage-item .top,
.index-content .advantage .advantage-phone .advantage-item .top {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 10px;
}

.index-content .advantage .advantage-pc .advantage-item .bottom,
.index-content .advantage .advantage-phone .advantage-item .bottom {
    font-size: 16px;
}

.index-content .advantage .advantage-pc .advantage-item {
    border-left: 1px solid rgb(84, 112, 148);
}

.index-content .advantage .advantage-pc .advantage-item:last-child {
    border-right: 1px solid rgb(84, 112, 148);
}

.index-content .advantage .advantage-phone {
    display: none;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
}

.index-content .advantage .advantage-phone .advantage-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: calc(100% / 2 - 2px);
    color: #fff;
}

.index-content .advantage .advantage-phone .advantage-item:nth-child(1),
.index-content .advantage .advantage-phone .advantage-item:nth-child(2) {
    border-bottom: 1px solid rgb(84, 112, 148);
}

.index-content .advantage .advantage-phone .advantage-item:nth-child(1),
.index-content .advantage .advantage-phone .advantage-item:nth-child(3) {
    border-right: 1px solid rgb(84, 112, 148);
}

.index-content .choose-us {
    width: 95%;
    padding: 20px 0;
    margin: 50px auto;
}

.index-content .choose-us .top {
    text-align: center;
}

.index-content .choose-us .top .title {
    font-size: 50px;
    margin-bottom: 10px;
}

.index-content .choose-us .top .tips {
    font-size: 18px;
    line-height: 36px;
}

.index-content .choose-us .bottom {
    display: flex;
    margin: 80px auto 0;
}

.index-content .choose-us .bottom .choose-item {
    display: flex;
    width: calc(100% / 3);
    margin: 0 20px;
}

.index-content .choose-us .bottom .choose-item .left-icon {
    margin-right: 30px;
    color: var(--primary-color);
}
.index-content .choose-us .bottom .choose-item .left-icon i {
    font-size: 50px;
}

.index-content .choose-us .bottom .choose-item .right-content {
    display: flex;
    flex-direction: column;
}

.index-content .choose-us .bottom .choose-item .right-content .title {
    position: relative;
    font-size: 26px;
    margin-bottom: 50px;
}

.index-content .choose-us .bottom .choose-item .right-content .title::after {
    content: '';
    position: absolute;
    bottom: -25px;
    left: 0;
    width: 73px;
    height: 1px;
    background: #737373;
}

.index-content .choose-us .bottom .choose-item .right-content .tips {
    font-size: 18px;
    line-height: 28px;
    white-space: pre-line;
}

@media (max-width: 1200px) {
    .index-content .company-profile .learn-more-button {
        width: 20%;
    }
}

@media (max-width: 1000px) {
    .index-content .choose-us .bottom {
        flex-wrap: wrap;
    }

    .index-content .choose-us .bottom .choose-item {
        width: 100%;
        margin: 30px 0;
    }

    .index-content .choose-us .top .title {
        font-size: 40px;
    }

    .index-content .choose-us .bottom {
        margin: 60px auto 0;
    }
}

@media (max-width: 768px) {
    .index-content .company-profile .learn-more-button {
        width: 40%;
    }

    .index-content .advantage .advantage-phone {
        display: flex;
    }

    .index-content .advantage .advantage-pc {
        display: none;
    }

    .index-content .choose-us .top .title {
        font-size: 34px;
    }

    .index-content .choose-us .bottom {
        margin: 40px auto 0;
    }
}
</style>